module.exports = __webpack_public_path__ + "static/media/bg.2f01f4de.png";